import './AutomationEnd.css';

export default function AutomationEnd() {
  const cards = [
    {
      id: 1,
      percentage: '15+',
      description: 'Years of Trust',
   },
    {
      id: 2,
      percentage: '15+',
      description: 'Years of Trust',
    },
    {
      id: 3,
      percentage: '15+',
      description: 'Years of Trust',
    },
    {
      id: 4,
      percentage: '15+',
      description: 'Years of Trust',
    }
  ];

  return (
    <div id="automation-end" className='outsourcemainclass'>
      <div className="left">
        <h2 className="heading">End-to-End IT Outsourcing Services</h2>
        <p className="subheading">
         We offer flexible and scalable IT outsourcing solutions tailored to your business needs. Our services include dedicated developers, skilled development teams, web and mobile app development, and comprehensive QA testing. With our technical expertise and adaptable engagement models, we help improve efficiency, reduce costs, and accelerate growth while you focus on your core business.
        </p>
      </div>
      <div className="right">
        <div className="cards">
          {cards.map((card) => (
            <div key={card.id} className="card">
              <h1>{card.percentage}</h1>
              <span>{card.description}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}